// src/helpers.ts

import axios from "axios";

export const getApiUrl = () => {
  // 1. Explicit override always wins (e.g. point dev at staging)
  const envEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT;
  if (envEndpoint) {
    console.log("📡 Using GraphQL endpoint from REACT_APP_GRAPHQL_ENDPOINT:", envEndpoint);
    return envEndpoint;
  }

  // 2. Default to localhost in dev, production in prod.
  // NODE_ENV is automatically set by Create React App:
  //   `yarn start` → NODE_ENV=development → localhost
  //   `yarn build` → NODE_ENV=production  → prod backend
  // No need to set REACT_APP_ENV manually — this just works.
  // In dev, derive the backend host from whatever host loaded the page so a
  // second laptop / phone on the same Wi-Fi hitting http://192.168.x.y:<port>
  // talks to the same machine's backend on :4000 instead of their own localhost.
  const isDev = process.env.NODE_ENV === "development";
  const devHost = typeof window !== "undefined" && window.location?.hostname
    ? window.location.hostname
    : "localhost";
  const endpoint = isDev
    ? `http://${devHost}:4000/graphql`
    : "https://business-builder-backend-sy9bw.ondigitalocean.app/graphql";

  console.log(`📡 Using GraphQL endpoint (NODE_ENV=${process.env.NODE_ENV}):`, endpoint);
  return endpoint;
};


export const getBitcoinPrice = async (): Promise<number> => {
  try {
    const response = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=aud");
    return response.data.bitcoin.aud;
  } catch (error) {
    console.error("Error fetching BTC price:", error);
    return 0; // Return 0 or some default value in case of an error
  }
};

export const calculateBTCAmount = (audAmount: number, btcPrice: number): number => {
  return audAmount / btcPrice;
};

/**
 * Ensures an IPFS gateway URL has the https:// protocol.
 */
export const normalizeIpfsUrl = (url: string): string => {
  if (!url) return url;

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  if (url.includes('files.tommillerservices.com')) {
    return `https://${url}`;
  }

  return url;
};

/**
 * Normalizes a media URL for display.
 */
export const normalizeMediaUrl = (url?: string): string => {
  if (!url) return '';
  return normalizeIpfsUrl(url);
};

